module.exports = __webpack_public_path__ + "static/media/icon-fan-blue.3ce4f762.png";